import { Controller } from '@hotwired/stimulus'
import type { GraphData } from '@app/application/report/screens/graphs-echarts/types'
import { EchartsChartManager } from '@app/shared/echarts/echarts-chart-manager'

export default class extends Controller {
  static values = {
    options: Object,
  }

  declare optionsValue: GraphData
  private manager = new EchartsChartManager()

  connect(): void {
    if (this.optionsValue) {
      void this.manager.init(this.element as HTMLElement, this.optionsValue)
    }
  }

  disconnect(): void {
    this.manager.dispose()
  }

  optionsValueChanged(): void {
    if (this.optionsValue) {
      void this.manager.update(this.optionsValue)
    }
  }
}
